const trainingLevelLabels = {
  private: 'Private',
  instrument: 'Instrument',
  commercial: 'Commercial',
  multi_engine: 'Multi-Engine',
  instructor: 'Instructor',
  atp: 'ATP'
};

export const formatTrainingLevel = (trainingLevel) => (
  trainingLevelLabels[trainingLevel] || String(trainingLevel || '').replaceAll('_', ' ')
);
